import { connect } from 'react-redux';
import { createSelector } from 'reselect';
import FrameworkUtils from 'utils/framework';
const { wrapHOC } = FrameworkUtils;

import { ROOT_BASKET_TYPES } from 'constants/RwdBasket';
const { MAIN_BASKET, PRE_BASKET } = ROOT_BASKET_TYPES;

import { getCartComponentLists } from 'viewModel/rwdBasket/rwdBasketRoot/helpers/getCartComponentLists';
import { getTopContentMessageComponentList } from 'viewModel/rwdBasket/rwdBasketRoot/helpers/getTopContentMessageComponentList';
import { getBottomContentComponentList } from 'viewModel/rwdBasket/rwdBasketRoot/helpers/getBottomContentMessageComponentList';
import { getCmsInfoModalCallbacks } from 'viewModel/rwdBasket/rwdBasketRoot/helpers/getCmsInfoModalCallbacks';
import { showSwapGiftCardBiBenefitBasketSelector } from 'viewModel/selectors/testTarget/showSwapGiftCardBiBenefitBasketSelector';
import { showBasketSaveForLaterSelector } from 'viewModel/selectors/testTarget/showBasketSaveForLaterSelector';
import { isOmniRewardEnabledSelector } from 'viewModel/selectors/basket/isOmniRewardEnabled/isOmniRewardEnabledSelector';

import BasketPageSelector from 'selectors/page/rwdBasket/basketSelector';
const { basketPageSelector } = BasketPageSelector;

import { globalModalsSelector } from 'selectors/page/headerFooterTemplate/data/globalModals/globalModalsSelector';
import BasketUserDataSelector from 'selectors/page/rwdBasket/basketUserDataSelector';
const { basketUserDataSelector } = BasketUserDataSelector;
import availableRrcCouponsSelector from 'selectors/availableRrcCoupons/availableRrcCouponsSelector';
import ccTargetersSelector from 'selectors/page/rwdBasket/ccTargetersSelector';
import ccBannerSelector from 'selectors/creditCard/ccBannerSelector';

import rewardsSelector from 'selectors/rewards/rewardsSelector';
import {
    saveForLaterListIdSelector,
    saveForLaterItemsSelector,
    saveForLaterLoadingSelector,
    saveForLaterErrorSelector,
    basketConfirmationSelector
} from 'selectors/saveForLater/saveForLaterSelectors';
import SaveForLaterActions from 'actions/SaveForLaterActions';
import Actions from 'actions/Actions';
import promoSelector from 'selectors/promo/promoSelector';
import rwdCheckoutErrorsSelector from 'selectors/page/rwdBasket/checkoutErrorsSelector';
import { hideFreeSamplesOnBasketSelector } from 'viewModel/selectors/testTarget/hideFreeSamplesOnBasketSelector';
import RwdBasketActions from 'actions/RwdBasketActions/RwdBasketActions';
const {
    resetNavigation, goToPickUpBasket, goToDCBasket, goToPreBasket, resetScrollToTop, refreshBasket
} = RwdBasketActions;

import localeUtils from 'utils/LanguageLocale';
import RwdBasketUtils from 'utils/RwdBasket';
const {
    getCartInfo, getPaymentInfo, getMessageInfo, getBiBenefitsInfo, getGiftCardInfo
} = RwdBasketUtils;
import SaveForLaterUtils from 'utils/SaveForLaterUtils';
import skuUtils from 'utils/Sku';
import Empty from 'constants/empty';

const { prepareSaveForLaterCarouselData } = SaveForLaterUtils;

const fields = createSelector(
    basketPageSelector,
    basketUserDataSelector,
    rewardsSelector,
    availableRrcCouponsSelector,
    ccTargetersSelector,
    promoSelector,
    rwdCheckoutErrorsSelector,
    ccBannerSelector,
    hideFreeSamplesOnBasketSelector,
    globalModalsSelector,
    showSwapGiftCardBiBenefitBasketSelector,
    showBasketSaveForLaterSelector,
    isOmniRewardEnabledSelector,
    saveForLaterListIdSelector,
    saveForLaterItemsSelector,
    saveForLaterLoadingSelector,
    saveForLaterErrorSelector,
    basketConfirmationSelector,
    (
        {
            basket,
            isInitialized: basketIsInitialized,
            shouldScrollToTop,
            currentRootBasketType,
            currentMainBasketType,
            isPreBasketAvailable,
            confirmationBoxOptions,
            cmsData
        },
        user,
        rewardsBazaarRewards,
        rougeRewardsCoupons,
        ccTargeters,
        promo,
        rwdCheckoutErrors,
        ccBanner,
        hideFreeSamplesOnBasket,
        globalModals,
        swapGiftCardBiBenefitBasket,
        showBasketSaveForLater,
        isOmniRewardEnabled,
        saveForLaterListId,
        saveForLaterItems,
        saveForLaterLoading,
        saveForLaterError,
        saveForLaterBasketConfirmation
    ) => {
        if (!basketIsInitialized) {
            return { isInitialized: false };
        }

        // INFL-2347 - use remainToFreeShipping to calculate if Guest user has met threshold for free shipping threshold
        const hasMetFreeShippingThreshhold = basket.remainToFreeShipping == null;

        const cartInfo = getCartInfo({
            basket,
            user,
            confirmationBoxOptions,
            hasMetFreeShippingThreshhold,
            rwdCheckoutErrors
        });
        const messageInfo = getMessageInfo({ basket, pickupBasket: basket.pickupBasket, cartInfo });
        const infoModalCallbacks = getCmsInfoModalCallbacks(cmsData, globalModals);
        const bottomContentComponentList = getBottomContentComponentList(cmsData, basket);
        const isEmptyBasket = basket.itemCount === 0 && basket.pickupbasketItemCount === 0;
        const showForCanadaDesktop = localeUtils.isCanada() && !Sephora.isMobile();
        const rawSaveForLaterItems = Array.isArray(saveForLaterItems) ? saveForLaterItems : Empty.Array;
        const savedSkuIdsSet = rawSaveForLaterItems.length
            ? new Set(rawSaveForLaterItems.map(item => item?.skuId || item?.sku?.skuId).filter(Boolean))
            : null;

        // Prepare Save For Later carousel data (only if feature is enabled and items exist)
        const saveForLaterCarouselData = prepareSaveForLaterCarouselData({
            isEnabled: !!showBasketSaveForLater,
            items: rawSaveForLaterItems,
            listId: saveForLaterListId
        });

        const oosBiOrSample = () => {
            const OOSObj = {
                isBiOOS: false,
                isSampleOOS: false
            };
            const sampleBasket = basket.items.filter(item => {
                const { sku } = item;

                return skuUtils.isSample(sku) && sku.isOutOfStock;
            });

            if (sampleBasket.length > 0) {
                OOSObj.isSampleOOS = true;
            }

            const BiBasket = basket.items.filter(item => {
                const { sku } = item;

                return sku.isBiOnly && sku.isOutOfStock;
            });

            if (BiBasket.length > 0) {
                OOSObj.isBiOOS = true;
            }

            return OOSObj;
        };

        return {
            isInitialized: true,
            currentRootBasketType,
            currentMainBasketType,
            isPreBasketAvailable,
            basket,
            cartComponentListsParams: {
                cartInfo,
                user,
                messageInfo: messageInfo[MAIN_BASKET],
                infoModalCallbacks: infoModalCallbacks[MAIN_BASKET],
                isOmniRewardEnabled,
                showSaveForLater: !!showBasketSaveForLater,
                savedSkuIdsSet,
                basketConfirmation: saveForLaterBasketConfirmation,
                userId: user.userId,
                listId: saveForLaterListId
            },
            userId: user.userId,
            isSignedIn: user.isSignedIn,
            isBIUser: user.isBIUser,
            hasMetFreeShippingThreshhold,
            preferredZipCode: user.preferredZipCode,
            preferredStoreInfo: user.preferredStoreInfo,
            cartInfo: {
                ...cartInfo,
                promo
            },
            paymentInfo: getPaymentInfo({
                basket,
                user,
                cartInfo,
                infoModalCallbacks: infoModalCallbacks[MAIN_BASKET],
                hasMetFreeShippingThreshhold
            }),
            messageInfo,
            bottomContentComponentList,
            biBenefitsInfo: getBiBenefitsInfo(
                {
                    basket,
                    user,
                    cmsData,
                    rougeRewardsCoupons,
                    infoModalCallbacks: infoModalCallbacks[MAIN_BASKET],
                    rewardsBazaarRewards,
                    ccTargeters,
                    biBenefitsPromos: promo,
                    ccBanner,
                    rwdCheckoutErrors,
                    isOmniRewardEnabled,
                    currentMainBasketType
                },
                hideFreeSamplesOnBasket
            ),
            giftCardInfo: getGiftCardInfo(cartInfo, cmsData),
            topContentMessageComponentList: getTopContentMessageComponentList({
                basket,
                user,
                cartInfo,
                cmsData,
                showBasketShippingAndPoints: !isEmptyBasket && !user.isSignedIn
            }),
            preBasketInfoModalCallbacks: infoModalCallbacks[PRE_BASKET],
            shouldScrollToTop,
            rwdCheckoutErrors,
            swapGiftCardBiBenefitBasket,
            showBasketGreyBackground: showForCanadaDesktop,
            showMoveBasketCheckoutButton: !isEmptyBasket,
            showSaveForLater: !!showBasketSaveForLater,
            saveForLaterCarouselData,
            saveForLaterLoading,
            oosBiOrSample: oosBiOrSample()
        };
    }
);

const functions = {
    resetNavigation,
    goToPickUpBasket,
    goToDCBasket,
    goToPreBasket,
    resetScrollToTop,
    refreshBasket,
    getSaveForLaterLists: SaveForLaterActions.getSaveForLaterLists,
    clearBasketConfirmation: SaveForLaterActions.clearBasketConfirmation,
    undoAddToSaveForLater: SaveForLaterActions.undoAddToSaveForLater,
    showSavedForLaterModal: Actions.showSavedForLaterModal
};

/**
 * Memoized selector for cartComponentLists with dispatch-wrapped action creators.
 */
const getCartComponentListsWithDispatch = createSelector(
    stateProps => stateProps.cartComponentListsParams,
    (_, dispatchProps) => dispatchProps.clearBasketConfirmation,
    (_, dispatchProps) => dispatchProps.undoAddToSaveForLater,
    (_, dispatchProps) => dispatchProps.showSavedForLaterModal,
    (cartComponentListsParams, clearBasketConfirmation, undoAddToSaveForLater, showSavedForLaterModal) => {
        if (!cartComponentListsParams) {
            return undefined;
        }

        return getCartComponentLists({
            ...cartComponentListsParams,
            clearBasketConfirmation,
            undoAddToSaveForLater,
            showSavedForLaterModal
        });
    }
);

/**
 * Merges state props and dispatch props, calling getCartComponentLists with
 * dispatch-wrapped action creators.
 */
const mergeProps = (stateProps, dispatchProps, ownProps) => {
    const { cartComponentListsParams, ...restStateProps } = stateProps;

    // Use memoized selector to avoid unnecessary re-renders
    const cartComponentLists = getCartComponentListsWithDispatch(stateProps, dispatchProps);

    return {
        ...ownProps,
        ...restStateProps,
        ...dispatchProps,
        cartComponentLists
    };
};

const withBasketRootProps = wrapHOC(connect(fields, functions, mergeProps));

export {
    withBasketRootProps, fields, functions
};
